import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { getBrandRows } from './brands/brandData';
import MarqueeRow from './brands/MarqueeRow';
import BrandsHeader from './brands/BrandsHeader';
import './brands/marquee.css';

const FADE_HIDDEN = { opacity: 0 };
const FADE_VISIBLE = { opacity: 1 };
const ROWS_TRANSITION = { delay: 0.3, duration: 0.8 };
const BOTTOM_TRANSITION = { delay: 0.8, duration: 0.6 };
const IN_VIEW_OPTS = { once: true, amount: 0.3 };
const { topRow, middleRow, bottomRow } = getBrandRows();

const ClientBrands = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, IN_VIEW_OPTS);
  const fade = isInView ? FADE_VISIBLE : FADE_HIDDEN;

  return (
    <section id="brands" className="py-8 md:py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-blue-500/5 via-purple-500/5 to-orange-500/5 rounded-full blur-3xl" />
      </div>
      <div ref={ref} className="relative z-10 max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
        <BrandsHeader isInView={isInView} t={t} />
        <motion.div initial={FADE_HIDDEN} animate={fade} transition={ROWS_TRANSITION} className="space-y-2 md:space-y-6">
          <MarqueeRow brands={topRow} direction="right" speed={9} />
          <MarqueeRow brands={middleRow} direction="left" speed={10} />
          <MarqueeRow brands={bottomRow} direction="right" speed={9.5} />
        </motion.div>
        <motion.div initial={FADE_HIDDEN} animate={fade} transition={BOTTOM_TRANSITION} className="text-center mt-4 md:mt-16">
          <p className="text-gray-500 text-sm" data-testid="brands-more-stories">{t.brands.moreStories}</p>
        </motion.div>
      </div>
    </section>
  );
};

export default ClientBrands;
